var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options.series.length > 0)?_c('v-chart',{attrs:{"options":_vm.options}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }